import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.map";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var FitnessTrends =
/*#__PURE__*/
function () {
  function FitnessTrends() {
    _classCallCheck(this, FitnessTrends);
  }

  _createClass(FitnessTrends, null, [{
    key: "member",
    value: function member(_ref) {
      var meta = _ref.meta,
          summary = _ref.summary,
          modules = _ref.modules;
      return {
        year: meta.year,
        firstName: meta.first_name,
        userId: meta.user_id,
        summary: {
          minutes: summary.minutes,
          activities: summary.activities || summary.activites,
          // temporarily accommodates a typo in the service
          friendCount: summary.friend_count,
          studioCount: summary.studio_count,
          cityCount: summary.city_count
        },
        tiles: modules.map(function (data, index) {
          return {
            description: data.description,
            id: index,
            header: data.header,
            number: data.number,
            subheader: data.subheader,
            type: data.type
          };
        })
      };
    }
  }]);

  return FitnessTrends;
}();